import React, { useEffect, useState, useRef } from 'react';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../Redux Store/actions';

//*MUI
import { Box, Card, Divider, Grid, Tab, Tabs, Tooltip } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

//*files
import cssClasses from './Profile.module.css';
import CustomInput from '../../Subcomponents/CustomInput';
import CheckCircleSharpIcon from '@mui/icons-material/CheckCircleSharp';
import CryptoJS from 'crypto-js';
import Button from '../../Subcomponents/Button';
import { errorTost, successTost } from '../../Services/Toast';
import EditIcon from '../../Components/Icons/EditIcon';
import { debounce, update } from 'lodash';
import CountdownTimer from '../../Subcomponents/CountDownTimer';
import PhoneInput from 'react-phone-number-input';
import { isValidPhoneNumber } from 'react-phone-number-input';
import {
  sendOTPMessage,
  sendMailTo,
  sendOTPMessageMail,
} from '../../Services/SmsService';
import {
  CheckIfEmailExistsInAuth,
  authUpDateSignUp,
  checkUserEmailExists,
  updateUser,
} from '../../Services/Users';
import MailIcon from '../../Assets/Images/Login/MailIcon.svg';
import { checkPhoneNumberIsBlackListed } from '../../Services/Lead';
import { dismissLoader, presentLoader } from '../../Services/loader';
import assignProjectImage from '../../Assets/Images/Project images/Frame 1208.svg';
import { getSalesProjects } from '../../Services/AssignProject';
import actions from '../../Redux Store/actions';
import ConfirmationAlert from '../../Subcomponents/ConfirmationAlert';
import { useNavigate } from 'react-router-dom';

function Profile() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);

  const [UserProjects, setUserProjects] = useState([]);

  const [tabs, setTab] = useState(['Personal Info', 'Assigned Projects']);
  const [tabValue, setTabValue] = useState('Personal Info');
  const [SaveEdit, setSaveEdit] = useState(false);
  const tabList = tabs.map((each, index) => {
    return (
      <Tab
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: 'Inter-Medium !important',
            fontStyle: 'normal !important',
            fontWeight: '500 !important',
            fontSize: '1.4rem !important',
            lineHeight: '2rem !important',
            textTransform: 'none !important',
          },
        ]}
      />
    );
  });

  const tabChange = (event, newValue) => {
    console.log(newValue);
    setTabValue(newValue);
  };

  const verifiedPhoneNumber = useRef(false);
  const [isLoadingEmail, setIsLoadingEmail] = useState(false);
  const [emailLabelText, setEmailLabelText] = useState('');

  const [updateProfile, setUpdateProfile] = useState({
    name: '',
    email: '',
    contactNumber: '',
  });
  const [helperText, setHelperText] = useState({
    name: '',
    email: '',
    isPhoneNumber: '',
    disableName: true,
    disableEmail: true,
    disableContactNumber: true,
    onChangePhoneNumber: false,
    onChangeEmail: false,
    changeOfEmail: false,
    changeOfNumber: false,
    changeOfName: false,
  });
  const verifiedEmail = useRef(false);
  const [otpTimerEmail, setOtpTimerEmail] = useState(false);
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [resendEmailButton, setResendEmailButton] = useState(false);
  const [emailState, setEmailState] = useState({
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: '',
  });
  const [receivedEmailOtp, setReceivedEmailOtp] = useState(null);
  // ------------------------Phone number otp
  const [showOtp, setShowOtp] = useState(false);
  const [isInterNational, setIsInterNational] = useState(false);
  const [resendButton, setResendButton] = useState(false);
  const [otpTimer, setOtpTimer] = useState(false);
  const [state, setState] = useState({
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: '',
  });
  const [receivedOtp, setReceivedOtp] = useState(null);
  const [sentEmail, setSentEmail] = useState(false);

  useEffect(() => {
    getProjectsData();
    setUpdateProfile((pre) => {
      pre.name = loggedInUser?.name;
      pre.email = loggedInUser?.email;
      pre.contactNumber = '+' + loggedInUser?.contactNumber;
      return { ...pre };
    });
    console.log('user------------', loggedInUser);
    console.log(loggedInUser);
    dispatch(actions.activeMenu('profile'));
  }, [loggedInUser]);

  function getProjectsData() {
    getSalesProjects(loggedInUser?.userId)
      .then((res) => {
        console.log('res', res);
        setUserProjects(res.data);
      })
      .catch((err) => {
        console.error('getSelectedProjects', err);
      });
  }

  const checkEmailExists = debounce((e) => {
    checkUserEmailExists(e)
      .then((emailCheckResp) => {
        console.log({ emailCheckResp });
        console.log('e', e);
        if (emailCheckResp.length > 0) {
          setHelperText((pre) => {
            pre.email = 'Email Already exists';
            return { ...pre };
          });
        } else {
          setHelperText((pre) => {
            pre.email = '';
            pre.onChangeEmail = true;
            return { ...pre };
          });
        }

        if (e === loggedInUser?.email) {
          setEmailLabelText('');
        } else {
          setEmailLabelText('Send Otp');
        }
      })
      .catch((error) => {
        console.log(error);
      });
    console.log('helpertext.email', helperText.email === '');
  }, 900);
  function sendOtpToVerifyEmail() {
    setHelperText((pre) => {
      pre.email = '';
      return { ...pre };
    });
    setShowEmailOtp(true);
    setOtpTimerEmail(true);
    setEmailLabelText('');
    let body = {
      email: updateProfile.email,
    };
    sendOTPMessageMail(body).then((resp) => {
      if (resp.data.success) {
        var bytes = CryptoJS.AES.decrypt(resp.data.otp, 'hts secret key');
        var originalText = bytes.toString(CryptoJS.enc.Utf8);
        console.log('Email Registration OTP', parseInt(originalText));
        setReceivedEmailOtp(parseInt(originalText));
        // 900000 ;15 min
        const myTimeout = setTimeout(smsTimeOutForEmailVerify, 900000);
      } else {
        if (resp?.data?.error?.ErrorMessage) {
          errorTost(resp?.data?.error?.ErrorMessage);
        } else {
          errorTost('Something went wrong');
        }
      }
    });
  }
  function smsTimeOutForEmailVerify() {
    if (verifiedEmail === false) {
      setHelperText((pre) => {
        pre.email = 'Otp has expired.Please resend otp';
        return { ...pre };
      });
      setEmailLabelText('Resend Otp');
      setOtpTimerEmail(false);
      // setVerifiedEmail(false);
      verifiedEmail.current = false;
    } else {
      setShowEmailOtp(true);
      setOtpTimerEmail(true);
      setEmailState((pre) => {
        pre.otp1 = '';
        pre.otp2 = '';
        pre.otp3 = '';
        pre.otp4 = '';
        return { ...pre };
      });
      setReceivedEmailOtp(null);
    }
  }
  // !!Email otp
  function optEmailChange(value1, event) {
    event.preventDefault();
    setEmailState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }

  function smsApiCall() {
    setResendButton(false);
    // const myTimeout = setTimeout(() => {
    //   setResendButton(true);
    // }, 180000);
    setState((pre) => {
      pre.otp1 = '';
      pre.otp2 = '';
      pre.otp3 = '';
      pre.otp4 = '';
      return { ...pre };
    });
    setShowOtp(true);
    let body = {
      number: updateProfile.contactNumber,
      isInterNational: isInterNational,
    };
    console.log(body);

    sendOTPMessage(body)
      .then((resp) => {
        if (resp.data.success) {
          var bytes = CryptoJS.AES.decrypt(resp.data.otp, 'hts secret key');
          var originalText = bytes.toString(CryptoJS.enc.Utf8);
          console.log('FOS Registration OTP', parseInt(originalText));
          setReceivedOtp(parseInt(originalText));
          // 900000 ;15 min
          const myTimeout = setTimeout(smsTimeOut, 900000);
        } else {
          if (resp?.data?.error?.ErrorMessage) {
            errorTost(resp?.data?.error?.ErrorMessage);
          } else {
            errorTost('Something went wrong');
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log(err.message);
      });
  }

  function smsTimeOut() {
    if (verifiedPhoneNumber.current === false) {
      setHelperText((pre) => {
        pre.isPhoneNumber = 'Otp has expired.Please resend otp';
        return { ...pre };
      });
      verifiedPhoneNumber.current = false;
      setShowOtp(true);
      setResendButton(true);
      setOtpTimer(true);
      // setShowEmailOtp(false);
      setState((pre) => {
        pre.otp1 = '';
        pre.otp2 = '';
        pre.otp3 = '';
        pre.otp4 = '';
        return { ...pre };
      });
      setReceivedOtp(null);
    }
  }
  const inputfocus = (elmnt) => {
    if (elmnt.key === 'Delete' || elmnt.key === 'Backspace') {
      // const next = elmnt.target.tabIndex - 2;
      // if (next > -1) {
      //     // elmnt.target.form.elements[next].focus();
      //     if (elmnt.target.nextSibling)
      //         elmnt.target.nextSibling.focus();
      // }
    } else {
      console.log('next');
      // const next = elmnt.target.tabIndex + 1;
      const next = parseInt(elmnt.target.id.split('-')[1]) + 1;
      if (next < 5) {
        // elmnt.target.form.elements[next].focus();
        if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
      }
    }
  };
  // !!For Email
  function submitEmailOtp() {
    let finalValue =
      emailState.otp1 + emailState.otp2 + emailState.otp3 + emailState.otp4;
    console.log(finalValue, 'receivedEmailOtp', receivedEmailOtp);
    if (finalValue == receivedEmailOtp) {
      // setVerifiedEmail(true);
      console.log('otp has been verified');
      verifiedEmail.current = true;
      setShowEmailOtp(false);
      setOtpTimerEmail(false);
      setEmailLabelText('');
      setEmailState((pre) => {
        pre.otp1 = '';
        pre.otp2 = '';
        pre.otp3 = '';
        pre.otp4 = '';
        return { ...pre };
      });
    } else {
      console.log('otp din match');
      setEmailState((pre) => {
        pre.otp1 = '';
        pre.otp2 = '';
        pre.otp3 = '';
        pre.otp4 = '';
        return { ...pre };
      });
      errorTost('OTP does not match.Please enter valid otp');
    }
  }

  const IsNumberBlackListed = debounce((e) => {
    console.log(e);
    checkPhoneNumberIsBlackListed(e)
      .then((resp) => {
        console.log(resp);
        verifiedPhoneNumber.current = false;
        // setVerifiedPhoneNumber(false);
        if (resp.length > 0) {
          setHelperText((pre) => {
            pre.isPhoneNumber = 'This number is already in use!';
            // pre.isPhoneNumber = "This number has been blacklisted";
            return { ...pre };
          });
        } else {
          setHelperText((pre) => {
            pre.isPhoneNumber = '';
            pre.onChangePhoneNumber = true;
            return { ...pre };
          });
          // setVerifiedPhoneNumber(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, 800);

  function optChange(value1, event) {
    event.preventDefault();
    setState((pre) => {
      pre[value1] = event.target.value;
      return Object.assign({}, pre);
    });
  }

  function submitOtp() {
    let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
    console.log(finalValue, 'recievedOtp', receivedOtp);
    if (finalValue == receivedOtp) {
      // setVerifiedPhoneNumber(true);
      verifiedPhoneNumber.current = true;
      setShowOtp(false);
      setOtpTimer(false);
      setHelperText((pre) => {
        pre.isPhoneNumber = '';
        return { ...pre };
      });
    } else {
      setState((pre) => {
        pre.otp1 = '';
        pre.otp2 = '';
        pre.otp3 = '';
        pre.otp4 = '';
        return { ...pre };
      });
      errorTost('OTP does not match.Please enter valid otp');
    }
  }

  function SettingBackToInitialState() {
    setSaveEdit(false);
    setHelperText((pre) => {
      pre.disableContactNumber = true;
      pre.onChangePhoneNumber = false;
      pre.disableEmail = true;
      pre.onChangeEmail = false;
      pre.disableName = true;
      return { ...pre };
    });
    verifiedPhoneNumber.current = false;
    verifiedEmail.current = false;
    dismissLoader();
  }

  async function UpdateToUserTable() {
    let obj = {
      name: updateProfile.name,
      contactNumber: updateProfile.contactNumber,
      email: updateProfile.email,
    };
    const UpdateUserResponse = await updateUser(obj, loggedInUser?.userId);
    if (UpdateUserResponse.data) {
      let postBody = {
        ...loggedInUser,
        name: UpdateUserResponse.data.name,
        contactNumber: UpdateUserResponse.data.contactNumber,
        email: UpdateUserResponse.data.email,
      };
      dispatch(actions.authLogin(postBody));
      //  successTost('Changes updated successfully!');
      SettingBackToInitialState()

      console.log('UpdateUserResponse.data', UpdateUserResponse.data);
    } else {
      if (UpdateUserResponse?.error?.message) {
        errorTost(UpdateUserResponse?.error?.message);
        SettingBackToInitialState();
      } else {
        errorTost('Something went wrong! Try again');
        SettingBackToInitialState();
      }
    }
  }

  async function OnSubmitInfo() {
    let obj = {
      name: updateProfile.name,
      contactNumber: updateProfile.contactNumber,
      email: updateProfile.email,
    };
    console.log('obj', obj);
    console.log(
      'loggedIn.userID',
      helperText.changeOfName,
      helperText.changeOfEmail,
      helperText.changeOfNumber
    );
    presentLoader();
    if (
      verifiedEmail.current ||
      verifiedPhoneNumber.current ||
      helperText.changeOfName
    ) {
      if (
        (helperText.changeOfEmail &&
          (helperText.changeOfName || helperText.changeOfNumber)) ||
        helperText.changeOfEmail
      ) {
        console.log('accepting changes');
        const UpdateAuthUser = await authUpDateSignUp({
          email: updateProfile.email,
        });
        if (UpdateAuthUser.user) {
          setSentEmail(true);
          UpdateToUserTable();
          dismissLoader();
        } else {
          console.log('error -<', UpdateAuthUser);
          if (UpdateAuthUser?.error?.message) {
            errorTost(UpdateAuthUser?.error?.message);
            SettingBackToInitialState();
          } else {
            errorTost('Something went wrong! Try again');
            SettingBackToInitialState();
          }
        }
      } else if (
        (helperText.changeOfName && helperText.changeOfNumber) ||
        helperText.changeOfNumber ||
        helperText.changeOfName
      ) {
        UpdateToUserTable();
      } else {
        errorTost('Nothing to Change!');
        dismissLoader();
      }
    } else {
      errorTost('Please verify details before saving');
      dismissLoader();
    }
  }
  return (
    <Box className={cssClasses.Container}>
      <Box mb={2} padding={'0 2.4rem'}>
        <Box className={cssClasses.HeaderTitle}>Profile</Box>
      </Box>

      <Box margin={'0 2rem'}>
        <Tabs
          value={tabValue}
          onChange={tabChange}
          variant='scrollable'
          scrollButtons='auto'
          aria-label='scrollable auto tabs'
          sx={[
            {
              borderBottom: '1px solid #EAECF0 !important',
            },
          ]}
        >
          {tabList}
        </Tabs>
      </Box>

      {tabValue === 'Personal Info' && (
        <>
          <Box className={cssClasses.wrapperHeader}>
            <Box width={'50%'}>
              <Box className={cssClasses.flexRow} m={3.7}>
                <Box className={cssClasses.flexColumn}>
                  <Box className={cssClasses.FirstTitle}>Personal info</Box>
                  <Box className={cssClasses.secondTitle}>
                    Update you personal details here.
                  </Box>
                </Box>
                {!SaveEdit && (
                  <>
                    <Box ml={'auto'}>
                      <Button
                        btnName={'Edit'}
                        style={{
                          color: '#1570EF',
                          boxShadow: 'none',
                          border: 'none',
                          backgroundColor: '#EFF8FF',
                        }}
                        clicked={() => {
                          setSaveEdit(true);
                          setHelperText((pre) => {
                            pre.disableName = false;
                            pre.disableEmail = false;
                            pre.disableContactNumber = false;
                            pre.onChangePhoneNumber = false;
                            pre.onChangeEmail = false;
                            return { ...pre };
                          });
                          if (
                            loggedInUser?.contactNumber ===
                            updateProfile.contactNumber
                          ) {
                            setHelperText((pre) => {
                              pre.onChangePhoneNumber = true;
                              return { ...pre };
                            });
                          }
                          if (loggedInUser?.email === updateProfile.email) {
                            setHelperText((pre) => {
                              pre.onChangeEmail = true;
                              return { ...pre };
                            });
                          }
                        }}
                      />
                    </Box>
                  </>
                )}
              </Box>

              <Divider variant='middle' />

              <Box m={3.7}>
                <Card>
                  <Box m={2}>
                    <Box mb={2}>
                      <CustomInput
                        placeholder={'enter your name'}
                        label={'Name'}
                        inputType={'label'}
                        value={updateProfile.name}
                        disabled={helperText.disableName}
                        handleChange={(newValue) => {
                          newValue = newValue.trimStart();
                          // var alphabet = /^[A-Z*\sa-z]*$/;
                          var alphabet = /^[A-Za-z\s]*$/;
                          if (newValue.match(alphabet) || newValue === '') {
                            if (newValue.length <= 40) {
                              setUpdateProfile((pre) => {
                                pre.name = newValue;
                                return { ...pre };
                              });
                            }
                          }
                          if (newValue !== '') {
                            setHelperText((pre) => {
                              pre.name = '';
                              return { ...pre };
                            });
                          } else {
                            helperText.name = 'Please Enter Name';
                          }

                          if (newValue !== loggedInUser?.name) {
                            setHelperText((pre) => {
                              pre.changeOfName = true;
                              return { ...pre };
                            });
                          }
                        }}
                        helperText={helperText.name}
                      />
                    </Box>

                    {loggedInUser.roleId.level !== 1 ? (
                      <Box mb={2}>
                        <CustomInput
                          value={updateProfile?.email}
                          label={'Email'}
                          inputType={'label'}
                          position={'start'}
                          image={'true'}
                          labelText={MailIcon}
                          disabled={
                            showEmailOtp ||
                            verifiedEmail.current === true ||
                            resendEmailButton ||
                            helperText.disableEmail
                          }
                          handleChange={(newValue) => {
                            console.log({ newValue });
                            setEmailLabelText('');
                            newValue = newValue.trimStart();
                            const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            if (!newValue.trim()) {
                              setEmailLabelText('');
                              helperText.email = 'Please Enter Email Id';
                            } else if (!newValue.match(emailIDCond)) {
                              setEmailLabelText('');
                              helperText.email =
                                'Please Enter Email in Proper Format';
                            } else {
                              setIsLoadingEmail(true);
                              setEmailLabelText('');
                              helperText.email = 'verifying...';
                              if (newValue !== '') {
                                checkEmailExists(newValue);
                              } else if (newValue === '') {
                                console.log('hii');
                                setEmailLabelText('');
                              }
                            }
                            if (newValue.length <= 100) {
                              setUpdateProfile((pre) => {
                                pre.email = newValue;
                                return { ...pre };
                              });
                            }

                            if (newValue !== loggedInUser?.email) {
                              setHelperText((pre) => {
                                pre.changeOfEmail = true;
                                return { ...pre };
                              });
                            }
                          }}
                          placeholder='Enter  Email'
                        />

                        <Box
                          display={'flex'}
                          flexDirection={'row'}
                          width={'100%'}
                        >
                          {helperText.email === '' &&
                            verifiedEmail.current &&
                            otpTimerEmail === false && (
                              <Box className={cssClasses.EmailIcon}>
                                <CheckCircleSharpIcon
                                  style={{
                                    fontSize: '2.5rem',
                                    marginRight: '1rem',
                                  }}
                                  color={'success'}
                                />
                              </Box>
                            )}
                        </Box>
                        <Box display={'flex'} flexDirection={'row'}>
                          <p
                            style={{
                              color: 'red',
                              fontSize: '1.4rem',
                              lineHeight: '1.66',
                            }}
                          >
                            {helperText.email}
                          </p>
                          {emailLabelText &&
                            helperText.email === '' &&
                            verifiedEmail.current === false &&
                            otpTimerEmail === false &&
                            showEmailOtp === false &&
                            updateProfile.email !== '' &&
                            !helperText.disableEmail &&
                            helperText.onChangeEmail && (
                              <div
                                className={cssClasses.verifyOtp}
                                onClick={(e) => {
                                  sendOtpToVerifyEmail(e);
                                }}
                              >
                                Verify Otp
                              </div>
                            )}

                          {verifiedEmail.current === false &&
                            showEmailOtp === true &&
                            resendEmailButton === true && (
                              <div
                                className={cssClasses.verifyOtp}
                                onClick={() => {
                                  setHelperText((pre) => {
                                    pre.email = '';
                                    return { ...pre };
                                  });
                                  if (resendEmailButton) {
                                    sendOtpToVerifyEmail();
                                    // successTost("Otp has been sent");
                                  } else {
                                    console.log('Please wait for 3 min');
                                  }
                                }}
                              >
                                Resend Otp
                              </div>
                            )}

                          {otpTimerEmail && (
                            <div className={cssClasses.resendOtp}>
                              {' '}
                              Resend Otp in{' '}
                              <CountdownTimer
                                startFrom={180}
                                onComplete={() => {
                                  setEmailLabelText('Resend Otp');
                                  setOtpTimerEmail(false);
                                }}
                                timeFormatter={(time) => {
                                  return (
                                    <span>
                                      {`0${Math.floor(time / 60)}`.slice(-2)}:
                                      {`0${time % 60}`.slice(-2)}
                                    </span>
                                  );
                                }}
                              />
                            </div>
                          )}
                        </Box>
                        {showEmailOtp && (
                          <div className={cssClasses.otpContainer}>
                            <input
                              className={cssClasses.otpInput}
                              name='otp1'
                              type='text'
                              autoComplete='off'
                              value={emailState.otp1}
                              // onKeyPress={keyPressed}
                              onChange={(e) => optEmailChange('otp1', e)}
                              tabIndex='1'
                              maxLength='1'
                              onKeyUp={(e) => inputfocus(e)}
                              id='opt-0'
                            />
                            <input
                              name='otp2'
                              type='text'
                              autoComplete='off'
                              className={cssClasses.otpInput}
                              value={emailState.otp2}
                              onChange={(e) => optEmailChange('otp2', e)}
                              tabIndex='2'
                              maxLength='1'
                              onKeyUp={(e) => inputfocus(e)}
                              id='opt-1'
                            />
                            <input
                              name='otp3'
                              type='text'
                              autoComplete='off'
                              className={cssClasses.otpInput}
                              value={emailState.otp3}
                              onChange={(e) => optEmailChange('otp3', e)}
                              tabIndex='3'
                              maxLength='1'
                              onKeyUp={(e) => inputfocus(e)}
                              id='opt-2'
                            />
                            <input
                              name='otp4'
                              type='text'
                              autoComplete='off'
                              className={cssClasses.otpInput}
                              value={emailState.otp4}
                              onChange={(e) => optEmailChange('otp4', e)}
                              tabIndex='4'
                              maxLength='1'
                              onKeyUp={(e) => inputfocus(e)}
                              id='opt-3'
                            />

                            <Box width={'fit-content'}>
                              <Button
                                tabIndex={5}
                                style={{
                                  color: '#ffffff',
                                  backgroundColor: '#155EEF',
                                  fontSize: '1.4rem',
                                  lineHeight: '2rem',
                                }}
                                btnName={'Submit OTP'}
                                clicked={submitEmailOtp}
                              />
                            </Box>
                          </div>
                        )}
                      </Box>
                    ) : (
                      <Box mt={2}>
                        <CustomInput
                          placeholder={'Email'}
                          label={'Email'}
                          inputType={'label'}
                          value={loggedInUser.email}
                          disabled={true}
                        />
                      </Box>
                    )}

                    <Box>
                      <Box>
                        <Box className={cssClasses.inputTitle} mt={1}>
                          Contact
                        </Box>

                        <PhoneInput
                          defaultCountry='IN'
                          value={updateProfile.contactNumber}
                          disabled={
                            showOtp ||
                            verifiedPhoneNumber.current ||
                            resendButton ||
                            helperText.disableContactNumber
                          }
                          placeholder='Enter phone number'
                          onChange={(phone) => {
                            console.log({ phone });
                            setUpdateProfile((pre) => {
                              pre.contactNumber =
                                phone === undefined ? '+91' : phone;
                              return { ...pre };
                            });
                            console.log(
                              '+' + loggedInUser?.contactNumber.toString() ===
                              updateProfile.contactNumber.toString()
                            );
                            if (
                              '+' + loggedInUser?.contactNumber.toString() ===
                              updateProfile.contactNumber.toString()
                            ) {
                              setHelperText((pre) => {
                                pre.onChangePhoneNumber = false;
                                return { ...pre };
                              });
                            } else {
                              setHelperText((pre) => {
                                pre.onChangePhoneNumber = true;
                                return { ...pre };
                              });
                            }
                            if (phone !== undefined) {
                              console.log(phone.length);
                              console.log(isValidPhoneNumber(phone));

                              // setVerifiedPhoneNumber(false);
                              verifiedPhoneNumber.current = false;
                              if (phone.length >= 1) {
                                if (isValidPhoneNumber(phone) === false) {
                                  verifiedPhoneNumber.current = false;
                                  helperText.isPhoneNumber = `Please Enter valid Phone Number`;
                                  setShowOtp(false);
                                } else {
                                  helperText.isPhoneNumber = 'verifying...';
                                  if (phone?.substring(0, 3) === '+91') {
                                    setIsInterNational(false);
                                  } else {
                                    setIsInterNational(true);
                                  }
                                  IsNumberBlackListed(phone);
                                }
                              }
                            } else {
                              helperText.isPhoneNumber =
                                'Please Enter  Phone Number';
                              setShowOtp(false);
                            }
                            console.log(
                              'helperText.isPhoneNumber',
                              helperText.isPhoneNumber
                            );

                            if (phone !== loggedInUser?.contactNumber) {
                              setHelperText((pre) => {
                                pre.changeOfNumber = true;
                                return { ...pre };
                              });
                            }
                          }}
                        />
                        <Box
                          display={'flex'}
                          flexDirection={'row'}
                          width={'100%'}
                        >
                          {helperText.isPhoneNumber === '' &&
                            verifiedPhoneNumber.current &&
                            otpTimer === false && (
                              <Box className={cssClasses.successIcon}>
                                <CheckCircleSharpIcon
                                  style={{
                                    fontSize: '2.5rem',
                                    marginRight: '1rem',
                                  }}
                                  color={'success'}
                                />
                              </Box>
                            )}
                        </Box>

                        <Box display={'flex'} flexDirection={'row'}>
                          <p
                            style={{
                              color: 'red',
                              fontSize: '1.4rem',
                              lineHeight: '1.66',
                            }}
                          >
                            {helperText.isPhoneNumber}
                          </p>

                          {helperText.isPhoneNumber === '' &&
                            verifiedPhoneNumber.current === false &&
                            otpTimer === false &&
                            showOtp === false &&
                            updateProfile.contactNumber !== '' &&
                            !helperText.disableContactNumber &&
                            helperText.onChangePhoneNumber && (
                              <div
                                className={cssClasses.verifyOtp}
                                onClick={() => {
                                  smsApiCall();
                                }}
                              >
                                Verify Otp
                              </div>
                            )}

                          {verifiedPhoneNumber.current === false &&
                            showOtp === true &&
                            resendButton === true && (
                              <div
                                className={cssClasses.verifyOtp}
                                onClick={() => {
                                  setHelperText((pre) => {
                                    pre.isPhoneNumber = '';
                                    return { ...pre };
                                  });
                                  if (resendButton) {
                                    smsApiCall();
                                    // successTost("Otp has been sent");
                                  } else {
                                    console.log('Please wait for 3 min');
                                  }
                                }}
                              >
                                Resend Otp
                              </div>
                            )}

                          {verifiedPhoneNumber.current === false &&
                            showOtp === true &&
                            resendButton === false && (
                              <div className={cssClasses.resendOtp}>
                                {' '}
                                Resend Otp in{' '}
                                {/* <Countdown date={startDate.current+ 180000} renderer={renderer} /> */}
                                <CountdownTimer
                                  startFrom={180}
                                  onComplete={() => {
                                    setResendButton(true);
                                  }}
                                  timeFormatter={(time) => {
                                    return (
                                      <span>
                                        {`0${Math.floor(time / 60)}`.slice(-2)}:
                                        {`0${time % 60}`.slice(-2)}
                                      </span>
                                    );
                                  }}
                                />
                              </div>
                            )}
                        </Box>

                        {showOtp && (
                          <div className={cssClasses.otpContainer}>
                            <input
                              className={cssClasses.otpInput}
                              name='otp1'
                              type='text'
                              autoComplete='off'
                              value={state.otp1}
                              // onKeyPress={keyPressed}
                              onChange={(e) => optChange('otp1', e)}
                              tabIndex='1'
                              maxLength='1'
                              onKeyUp={(e) => inputfocus(e)}
                              id='opt-0'
                            />
                            <input
                              name='otp2'
                              type='text'
                              autoComplete='off'
                              className={cssClasses.otpInput}
                              value={state.otp2}
                              onChange={(e) => optChange('otp2', e)}
                              tabIndex='2'
                              maxLength='1'
                              onKeyUp={(e) => inputfocus(e)}
                              id='opt-1'
                            />
                            <input
                              name='otp3'
                              type='text'
                              autoComplete='off'
                              className={cssClasses.otpInput}
                              value={state.otp3}
                              onChange={(e) => optChange('otp3', e)}
                              tabIndex='3'
                              maxLength='1'
                              onKeyUp={(e) => inputfocus(e)}
                              id='opt-2'
                            />
                            <input
                              name='otp4'
                              type='text'
                              autoComplete='off'
                              className={cssClasses.otpInput}
                              value={state.otp4}
                              onChange={(e) => optChange('otp4', e)}
                              tabIndex='4'
                              maxLength='1'
                              onKeyUp={(e) => inputfocus(e)}
                              id='opt-3'
                            />

                            <Box width={'fit-content'}>
                              <Button
                                tabIndex={5}
                                style={{
                                  color: '#ffffff',
                                  backgroundColor: '#155EEF',
                                  fontSize: '1.4rem',
                                  lineHeight: '2rem',
                                }}
                                btnName={'Submit OTP'}
                                clicked={submitOtp}
                              />
                            </Box>
                          </div>
                        )}
                      </Box>
                    </Box>

                    <Box mt={2}>
                      <CustomInput
                        placeholder={'User Type'}
                        label={'User Type'}
                        inputType={'label'}
                        value={loggedInUser.isCrmUser ? 'CRM' : 'Sales'}
                        disabled={true}
                      />
                    </Box>

                    <Box mt={2}>
                      <CustomInput
                        placeholder={'Role'}
                        label={'Role'}
                        inputType={'label'}
                        value={loggedInUser?.roleId?.title}
                        disabled={true}
                      />
                    </Box>

                    {loggedInUser.roleId.level !== 1 && (
                      <Box mt={2}>
                        <CustomInput
                          placeholder={'Parent'}
                          label={'Parent'}
                          inputType={'label'}
                          value={loggedInUser?.parentId?.name}
                          disabled={true}
                        />
                      </Box>
                    )}
                  </Box>
                </Card>
              </Box>

              {SaveEdit && (
                <>
                  <Box m={3.7}>
                    <Box className={cssClasses.flexRow}>
                      <Box width={'fit-Content'} ml={'auto'} mr={2}>
                        <Button
                          style={{
                            fontSize: '1.4rem',
                            lineHeight: '2rem',
                            color: '#344054',
                            backgroundColor: '#FFFFFF',
                            borderRadius: '0.8rem',
                          }}
                          padding={'0.7rem 1.6rem'}
                          btnName={'Cancel'}
                          clicked={() => {
                            setSaveEdit(false);
                            helperText.isPhoneNumber = "";
                          }}
                          // clicked={() => {
                          //   setSaveEdit(true);
                          // }}
                        />
                      </Box>

                      <Box width={'fit-Content'}>
                        <Button
                          style={{
                            color: '#fff',
                            backgroundColor: '#1570EF',
                            fontSize: '1.4rem',
                            lineHeight: '2rem',
                            fontFamily: 'Roboto-Regular',
                          }}
                          // disable={verifiedEmail.current === false || verifiedPhoneNumber.current === false || loggedInUser?.name === updateProfile?.name}
                          padding={'0.7rem 2.5rem'}
                          btnName={'Save'}
                          clicked={() => OnSubmitInfo()}
                        />
                      </Box>
                    </Box>
                  </Box>
                </>
              )}

              {sentEmail && (
                <ConfirmationAlert
                  confirm={(e) => {
                    console.log('e --> ', e);
                    if (e === 'confirmed') {
                      setSentEmail(false);
                      // UpdateToUserTable();
                      navigate('/login');
                    }
                  }}
                  // buttonTitle={"Done"}
                  hideCloseIcon={true}
                  returnRespButton={'Done'}
                  // close={() => {
                  //   setSentEmail(false);
                  // }}
                  title={'Verify Email'}
                  subTitle={`A link has been sent to your new registered email-id(${updateProfile.email}) for confirmation. Click on the link and  Please login through your new email-id`}
                  open={setSentEmail}
                />
              )}
            </Box>
          </Box>
        </>
      )}

      {tabValue === 'Assigned Projects' && (
        <>
          <div
            style={{
              margin: '2rem',
              overflow: 'auto',
              flex: '1',
              marginBottom: '1rem',
              padding: '1rem',
            }}
          >
            <Grid container spacing={2}>
              {UserProjects.map((elm, i) => (
                <Grid
                  item
                  xs={12}
                  md={4}
                  key={elm.projectId.projectId}
                  display={'flex'}
                >
                  <Card className={cssClasses.assignProjectCard}>
                    <Grid container spacing={1}>
                      <Grid item xs={3}>
                        <img
                          src={assignProjectImage}
                          alt='sad'
                          style={{
                            width: '100%',
                          }}
                        />
                      </Grid>
                      <Grid item xs={8} ml={2}>
                        <Box className={cssClasses.FirstTitle}>
                          {elm.projectId.projectName}
                        </Box>
                        <Box className={cssClasses.inputTitle}>
                          {' '}
                          Location :{' '}
                          {`${elm.projectId.addressLine1} ${elm.projectId.addressLine2
                            } ${elm.projectId.addressLine3
                              ? elm.projectId.addressLine3
                              : ''
                            }, ${elm.projectId.city} ${elm.projectId.country} `}
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </div>
        </>
      )}
    </Box>
  );
}

export default Profile;
